import { Outlet, NavLink, useLocation } from "react-router-dom";
import "../../../../common/styles/table.css";

/**
 * ImportHistoryLayout - Common layout for Import History section
 * Provides header, tab navigation (Students / Teachers), and renders child routes via Outlet
 * @param {Object} props
 * @param {"school-admin" | "teacher"} props.type - type of import history (school-admin or teacher)
 */
const ImportHistoryLayout = ({ type }) => {
  const location = useLocation();
  const isStudentsTab =
    location.pathname.includes("/students") ||
    location.pathname.endsWith("/import-history");

  return (
    <div>
      <div className="pb-4 fs-3 fw-semibold">
        {" "}
        {type === "teacher" && "Student "} Import History
      </div>
      <div>
        {type !== "teacher" && (
          <div className="tabs-container">
            <NavLink
              to={
                type === "school-admin"
                  ? "/school-admin/import-history/students"
                  : "/teacher/import-history/students"
              }
              className={({ isActive }) =>
                `tab-btn ${isActive || isStudentsTab ? "active" : ""}`
              }
            >
              Students
            </NavLink>
            <NavLink
              to={
                type === "school-admin"
                  ? "/school-admin/import-history/teachers"
                  : "/teacher/import-history/teachers"
              }
              className={({ isActive }) =>
                `tab-btn ${isActive ? "active" : ""}`
              }
            >
              Teachers
            </NavLink>
          </div>
        )}
      </div>

      <Outlet />
    </div>
  );
};

export default ImportHistoryLayout;
